import { useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { COMPANY } from "@/data/content";

export default function StickyMobileCta() {
  const { pathname } = useLocation();
  // Hide on contact page (form is the CTA there)
  if (pathname.startsWith("/contact")) return null;

  const num = COMPANY.whatsapp.replace(/\D/g, "");
  const text = encodeURIComponent(COMPANY.whatsappMessage);

  return (
    <div
      data-testid="sticky-mobile-cta"
      className="fixed inset-x-0 bottom-0 z-40 border-t-2 border-black bg-white shadow-brutal-lg lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="grid grid-cols-2">
        <a
          href={`tel:${COMPANY.phoneTel}`}
          data-testid="sticky-call"
          className="flex items-center justify-center gap-2 border-r-2 border-black bg-black px-3 py-3 text-sm font-bold uppercase tracking-wide text-[#FFD700]"
        >
          <Phone size={16} /> Call Now
        </a>
        <a
          href={`https://wa.me/${num}?text=${text}`}
          target="_blank"
          rel="noreferrer"
          data-testid="sticky-whatsapp"
          className="flex items-center justify-center gap-2 px-3 py-3 text-sm font-bold uppercase tracking-wide text-black"
          style={{ background: "#FFD700" }}
        >
          <svg viewBox="0 0 32 32" width="18" height="18" aria-hidden="true">
            <path
              fill="#25D366"
              d="M16 .5A15.5 15.5 0 0 0 2.6 23.7L.5 31.5l8-2.1A15.5 15.5 0 1 0 16 .5Zm7.3 19.2c-.4-.2-2.4-1.2-2.7-1.3-.4-.1-.6-.2-.9.2-.3.4-1 1.3-1.3 1.6-.2.3-.5.3-.9.1-.4-.2-1.7-.6-3.3-2-1.2-1.1-2-2.4-2.3-2.8-.2-.4 0-.6.2-.8.2-.2.4-.5.6-.7.2-.2.3-.4.4-.6.1-.3 0-.5 0-.7s-.9-2.2-1.3-3c-.3-.8-.7-.7-.9-.7h-.8c-.3 0-.7.1-1 .5s-1.3 1.3-1.3 3.2 1.4 3.7 1.6 4c.2.3 2.7 4.1 6.5 5.7 2.3 1 3.2 1.1 4.3.9.7-.1 2.2-.9 2.5-1.8.3-.9.3-1.6.2-1.8-.1-.2-.4-.3-.8-.5Z"
            />
          </svg>
          WhatsApp
        </a>
      </div>
    </div>
  );
}
